import React from "react";
import Card from "react-bootstrap/Card";

function EducationCard({ degree, institution, duration, score }) {
  return (
    <Card className="project-card-view">
      <Card.Body>
        <Card.Title style={{ fontWeight: "bold" }}>{degree}</Card.Title>
        {institution && <Card.Subtitle className="mb-2 text-muted">{institution}</Card.Subtitle>}
        <Card.Text style={{ textAlign: "justify" }}>
          <strong className="purple">Duration: </strong>{duration}
          <br />
          <strong className="purple">{score}</strong>
        </Card.Text>
      </Card.Body>
    </Card>
  );
}

export default EducationCard;
